var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    id: "Layer_1",
    "data-name": "home-private",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    fill: "#007F00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Remote") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M899.05,389.62c-.35-.29-.72-.56-1.09-.83L512.26,114.61a20.85,20.85,0,0,0-2.71-1.65c-12.07-6.22-21.33.38-27.45,4.75L102,388.81c-.37.27-.74.54-1.09.83-4.06,3.29-24.33,22.07-24.33,68.63V956.1c0,20.08,14.18,41.42,40.46,41.42H389.69c19.61,0,40.45-14.51,40.45-41.42V633.73H568.86V956.1c0,26.91,20.87,41.42,40.51,41.42H882.94c26.32,0,40.52-21.34,40.52-41.42V458.27C923.46,411.69,903.13,392.91,899.05,389.62Zm-778,566.48v-.23h0A2,2,0,0,1,121.09,956.1Zm757.82,0a2.07,2.07,0,0,1,0-.23h0Zm0-3.13H613.41V630.59c0-26.9-20.87-41.42-40.52-41.42H426.05c-19.62,0-40.46,14.52-40.46,41.42V953H121.09V458.27c0-22.27,6.58-32.1,8.32-34.31l370-263.85L870.57,424c1.74,2.21,8.34,12,8.34,34.29Zm87.62-603.51L803.11,233.55V24.75A22.28,22.28,0,0,0,780.83,2.48H694.42a22.28,22.28,0,0,0-22.28,22.27V140.67L513.54,28.18a22.29,22.29,0,0,0-12.89-4.1h-1.3a22.29,22.29,0,0,0-12.89,4.1l-453,321.28A22.27,22.27,0,1,0,59.24,385.8L500,73.21,940.76,385.8a22.27,22.27,0,1,0,25.77-36.34ZM716.7,47h41.85V202L716.7,172.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePrivate);
export default __webpack_public_path__ + "static/media/home-private.4f18b5feb7b5158a38ced40fea67348a.svg";
export { ForwardRef as ReactComponent };